module.exports = __webpack_public_path__ + "img/home-grid-card-building.5c5186fc.png";